export default __webpack_public_path__ + "locales/tr/EmptyView.json?hash=bb215a05dd929adee7da6d491c4eb000";